window.app.factory("copyToClipboard", [
  function() {
    return function copyToClipboard(str) {
      const el = document.createElement("textarea");
      el.value = str;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      const out = document.execCommand("copy");
      document.body.removeChild(el);
      return out;
    };
  }
]);



// WEBPACK FOOTER //
// ./src/services/copyToClipboard.js